import { DEFAULT_COLORS } from '@components/widgets/apacheEchart/Commons'
import { getCommonWidget } from '../../dashWidgetHelper'
import { commonWidgets, msurPorcRespuestasMapper, msurTooltipTotalRegistros } from '../commonWidgetsMedicasur'


const GROUP_LABELS_PERSONAL = {
    //'exp_hosp_enfermeria_trato': 'Enfermeria',
    'serv_rehab_personal_trato': 'Médicos',
    'serv_rehab_admision_personal': 'Admisión',
    //'exp_hosp_camilleros_trato': 'Camilleros',
    'serv_rehab_instalaciones_calidad': 'Instalaciones',
    //'exp_hosp_nutricion_informacion': 'Nutricion'
}

const GROUP_LABELS_ADMISION = {
    'serv_rehab_admision_trato': 'Trato',
    //'exp_hosp_admision_espera': 'Agilidad del registro',
    //'exp_hosp_seguros_egreso': 'Agilidad y atención del alta',
    'serv_rehab_admision_informacion': 'Claridad de la información'
}

//const GROUP_LABELS_ENFERMERIA = {
//    'exp_hosp_enfermeria_trato': 'Trato',
//    'serv_cidyt_enfermeria_privacidad': 'Privacidad, seguridad y respeto',
//    'serv_clin_enfermeria_explicacion': 'Explicación clara en la atención',
//    'exp_hosp_enfermeria_atencion': 'Atención oportuna'
//}

//const GROUP_LABELS_PERSONAL_MEDICO = {
//    'serv_rehab_personal_trato': 'Trato',
//    'exp_hosp_inf_y_ate_privacidad': 'Privacidad, seguridad y respeto',
//    'serv_clin_prof_explicacion': 'Claridad en la información',
//    'exp_hosp_inf_y_ate_consideraciones': 'Lo toma en cuenta',
//    'exp_hosp_medico_atencion': 'Atención oportuna'
//}

//const GROUP_LABELS_NUTRICION = {
    //'': 'Atención por la nutrióloga',
//    'exp_hosp_nutricion_sabor': 'Temperatura y presentación de los alimentos',
//    'exp_hosp_nutricion_informacion': 'Información sobre dieta'
//}

//const GROUP_LABELS_CAMILLERO = {
//    'exp_hosp_camilleros_trato': 'Trato y Tiempo de espera'
//}

//const GROUP_LABELS_PACIENTES_Y_FAMILIARES = {
//    'exp_hosp_paciente_estadia': 'Trato y Apoyo',
    //'': 'Explicación clara',
//    'exp_hosp_paciente_informacion': 'Utilidad de la guía de ingreso'
//}

const GROUP_LABELS_INSTALACIONES = {
    'serv_rehab_instalaciones_calidad': 'Calidad en general de las instalaciones',
    //'': 'Calidad de las habitaciones',
    //'serv_cidyt_instalacion_calidad': 'Calidad y Confort del inmobiliario'
}

const GROUP_LABELS_LIMPIEZA = {
    'serv_rehab_instalaciones_limpieza': 'Limpieza de las instalaciones',
    //'': 'Limpieza de las habitaciones',
    //'serv_cidyt_instalacion_limpieza_consultorio': 'Limpieza de las consultorios'
}


export default {
    title: 'Satisfacción servicios de rehabilitación',
    description: 'Dashboard de servicios de rehabilitación',
    backgroundClassName: (filters) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI, filtersData: Record<string, any>) => {
        return [
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Satisfacción General',
                size: [2, 2],
                indicator: 'serv_rehab_csat',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                },
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'serv_rehab_nps',
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS,
                    useCurrent: 0
                }
            }),
            
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: '¿Por qué seleccionó nuestro Hospital?',
                size: [3, 2],
                indicator: 'serv_rehab_motivo_eleccion',
                extraConfigs: {
                    decimals: 0
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGenericByStatus',
                title: 'Porcentaje de respuestas',
                indicator: 'general-respuestas-gauge',
                mapper: msurPorcRespuestasMapper,
                tooltipFormatter: msurTooltipTotalRegistros,
                size: [1, 2],
                url: 'dashboard/status',
                extraIndicatorConfigs: {
                    keyExtract: ['resume'],
                    singleton: true
                },
                extras: {
                    useLcmApi: true,
                    workflowName: 'serv_rehabilitacion'
                },
                extraConfigs: {
                    showPercentage: true,
                },
            }),
            

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: 'Satisfacción por Tipo de Personal',
                key: 'bar-by-question-personal',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_PERSONAL,
                    decimals: 0,
                    showPercentage: true,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_PERSONAL).join(","),
                },
                size: [4, 2],
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: 'Satisfacción hacia Admisión',
                key: 'bar-by-question-admision',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_ADMISION,
                    decimals: 0,
                    showPercentage: true,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_ADMISION).join(","),
                },
                size: [4, 2],
            }),
            
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: 'Satisfacción hacia las Instalaciones',
                key: 'bar-by-question-instalaciones',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_INSTALACIONES,
                    decimals: 0,
                    showPercentage: true,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_INSTALACIONES).join(","),
                },
                size: [2, 2],
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: 'Satisfacción hacia la Limpieza',
                key: 'bar-by-question-limpieza',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_LIMPIEZA,
                    decimals: 0,
                    showPercentage: true,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_LIMPIEZA).join(","),
                },
                size: [2, 2],
            }),





            {
                title: 'Personal',
                type: 'label',
                size: [4, 1],
                config: { color: '#B7AADC' },
            },


            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Personal de admisión capacitado',
                size: [2, 2],
                indicator: 'serv_rehab_admision_personal',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Personal médico cordial',
                size: [2, 2],
                indicator: 'serv_rehab_personal_trato',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            {
                title: 'Instalaciones y Limpieza',
                type: 'label',
                size: [4, 1],
                //config: { color: '#B7AADC' },
            },
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Calidad instalaciones',
                size: [2, 2],
                indicator: 'serv_rehab_instalaciones_calidad',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Limpieza instalaciones',
                size: [2, 2],
                indicator: 'serv_rehab_instalaciones_limpieza',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),


            {
                title: 'Experiencia y Recomendaciones',
                type: 'label',
                size: [4, 1],
                //config: { color: '#B7AADC' },
            },
            /*
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'wordCount',
                title: 'Comentarios',
                size: [2, 3],
                indicator: 'WORD_COUNT',

            }),*/
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'lastComments',
                size: [4, 2],
                indicator: 'COMMENTS',
                extraConfigs: {
                    maxCommentSize: 120
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'textAnalysis',
                title: 'Servicios a Pacientes y Familiares',
                size: [4, 3],
                indicator: 'SENTIMENT'
            }),            
        ]
    },
} as DasboardConfig
